export const languages = [
  { id: "sv", label: "Swedish" },
  { id: "en", label: "English" },
  { id: "fr", label: "French" },
];
